import { createSlice } from '@reduxjs/toolkit';
import { SearchStatus, FiltersInitialValue } from '../../constants';

const initialState = {
  carSearches: {},
  responses: {},
  error: {},
  carRateOptionRules: {},
};

const carSlice = createSlice({
  name: 'car',
  initialState,
  reducers: {
    updateCarSearchObj: (state, { payload: { tripId, defaultSearchObj, carTabs } }) => ({
      ...state,
      carSearches: {
        ...state.carSearches,
        [tripId]: {
          ...state.carSearches[tripId],
          carTabs: carTabs || state.carSearches[tripId].carTabs || {},
          defaultSearchObj: {
            ...FiltersInitialValue.car,
            ...(state.carSearches[tripId] || {}).defaultSearchObj,
            ...defaultSearchObj,
          },
        },
      },
    }),
    carSearch: (state, { payload: { tripId, selectedTab, searchObj, isTripSearch } }) => ({
      ...state,
      carSearches: isTripSearch
        ? state.carSearches
        : {
            ...state.carSearches,
            [tripId]: {
              ...state.carSearches[tripId],
              carTabs: {
                ...state.carSearches[tripId].carTabs,
                [selectedTab]: {
                  ...state.carSearches[tripId].carTabs[selectedTab],
                  searchStatus: SearchStatus.SEARCHING,
                  searchObj: searchObj
                    ? {
                        ...state.carSearches[tripId].carTabs[selectedTab].searchObj,
                        ...searchObj,
                      }
                    : {
                        ...state.carSearches[tripId].carTabs[selectedTab].searchObj,
                      },
                },
              },
            },
          },
    }),
    carSuccess: (
      state,
      {
        payload: {
          tab,
          queryString,
          response,
          tripId,
          rentalAgencyResults,
          carTypesResults,
          minBudget,
          maxBudget,
        },
      },
    ) => ({
      ...state,
      responses: {
        ...state.responses,
        [queryString]: {
          ...response,
        },
      },
      carSearches: {
        ...state.carSearches,
        [tripId]: {
          ...state.carSearches[tripId],
          carTabs: {
            ...state.carSearches[tripId].carTabs,
            [tab]: {
              ...state.carSearches[tripId].carTabs[tab],
              searchStatus: SearchStatus.DONE,
              queryString,
              rentalAgencyResults,
              carTypesResults,
              minBudget,
              maxBudget,
              currencyCode: response.currencyCode,
            },
          },
        },
      },
    }),
    carFailure: (state, { payload: { tab, tripId } }) => ({
      ...state,
      carSearches: {
        ...state.carSearches,
        [tripId]: {
          ...state.carSearches[tripId],
          carTabs: {
            ...state.carSearches[tripId].carTabs,
            [tab]: {
              ...state.carSearches[tripId].carTabs[tab],
              searchStatus: SearchStatus.DONE,
            },
          },
        },
      },
    }),

    getCarRateRulesRequest: (state, action) => ({
      ...state,
      carRateOptionRules: {
        ...state.carRateOptionRules,
        [action.payload.key]: {
          ...state.carRateOptionRules[action.payload.key],
          getCarRateRulesStatus: SearchStatus.SEARCHING,
        },
      },
    }),

    getCarRateRulesSuccess: (state, action) => {
      const { key, vendorMessages, carRateRules } = action.payload;
      const prev = state.carRateOptionRules[key] || {};
      return {
        ...state,
        carRateOptionRules: {
          ...state.carRateOptionRules,
          [key]: {
            ...prev,
            getCarRateRulesStatus: SearchStatus.DONE,
            vendorMessages: vendorMessages !== undefined ? vendorMessages : prev.vendorMessages,
            carRateRules: carRateRules !== undefined ? carRateRules : prev.carRateRules,
          },
        },
      };
    },
  },
});

export const {
  carSearch,
  carSuccess,
  carFailure,
  updateCarSearchObj,
  getCarRateRulesRequest,
  getCarRateRulesSuccess,
} = carSlice.actions;
export default carSlice.reducer;
